import type React from 'react';
import { Button, Modal } from 'shared-portal-components-v2';

import { JSON_STR_BASE } from '@/constants';

interface GlobalPollingModalProps {
  isOpen: boolean;
  title: string | undefined;
  message: string | undefined;
  details: unknown;
  onClose: () => void;
}

export function GlobalPollingModal({
  isOpen,
  title,
  message,
  details,
  onClose,
}: GlobalPollingModalProps): React.JSX.Element {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title ?? ''}
      ariaLabel={title ?? 'Modal'}
    >
      <div className="text-center">
        <p className="mb-2 text-gray-800">{message}</p>

        {details !== null && (
          <details className="mt-3 text-left">
            <summary className="cursor-pointer font-medium">Details</summary>
            <pre className="whitespace-pre-wrap text-sm mt-2 bg-gray-50 p-3 rounded">
              {JSON.stringify(details, null, JSON_STR_BASE)}
            </pre>
          </details>
        )}

        <div className="mt-4 flex justify-center">
          <Button variant="primary" size="md" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
}
